import api from './api'

/**
 * Admin login.
 * @param {string} email
 * @param {string} password
 * @returns {Promise<{ success: boolean, token: string, user: object }>}
 */
export async function login(email, password) {
  const { data } = await api.post('/auth/login', { email, password })
  return data
}
